import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { LoginPageFuehrung } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { MissionsPage } from './pages/MissionsPage'
import { KraefteManagementPage } from './pages/KraefteManagementPage'
import { TaktischeKartePage } from './pages/TaktischeKartePage'
import { RisikobewertungPage } from './pages/RisikobewertungPage'
import { LiveVideoPage } from './pages/LiveVideoPage'
import { SettingsPage } from './pages/SettingsPage'
import { MedienPage } from './pages/MedienPage'
import { FensterSeite } from './components/FensterSeite'
import { useAuth } from '@pilot-hub/auth'
import { MissionProvider, FeedbackPage, ConnectionProvider, EinsatzProvider } from '@pilot-hub/ui'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-500 border-t-transparent" />
      </div>
    )
  }

  if (user) {
    return <Navigate to="/verwaltung" replace />
  }

  return <>{children}</>
}

/** Einsatzwahl nur für angemeldete Nutzer (sonst würde /einsaetze/offen ohne Login abgefragt). */
function EinsatzScope({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  return <EinsatzProvider modul="fuehrung" userId={user?.id} endpoint="/einsaetze/offen" suggest="rang">{children}</EinsatzProvider>
}

function AppRoutes() {
  const router = useNavigate()
  // Expose router for LoginPage redirect without full reload
  ;(window as any).__PILOT_HUB_ROUTER__ = { navigate: router }
  return (
    <ConnectionProvider staleMs={60000}>
    <MissionProvider>
      <Routes>
      <Route path="/login" element={
        <PublicRoute>
          <LoginPageFuehrung />
        </PublicRoute>
      } />

      {/* Gelöste Ansicht (Multimonitor): ohne Layout, aber mit Anmeldung und Einsatzwahl */}
      <Route path="/fenster/:ansicht" element={
        <ProtectedRoute>
          <EinsatzScope><FensterSeite /></EinsatzScope>
        </ProtectedRoute>
      } />

      {/* Layout rendert <Outlet /> – Kind-Routen MÜSSEN hier im Config-Baum stehen,
          ein verschachteltes <Routes> als children wird von Layout nicht gerendert. */}
      <Route path="/" element={
        <ProtectedRoute>
          <EinsatzScope><Layout /></EinsatzScope>
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/verwaltung" replace />} />
        <Route path="verwaltung" element={<DashboardPage />} />
        <Route path="einsaetze" element={<MissionsPage />} />
        {/* frühere Live-Einsatz-Seite (ersetzt durch Dashboard und Taktische Karte) */}
        <Route path="einsaetze/:id" element={<Navigate to="/einsaetze" replace />} />
        <Route path="kraefte-management" element={<KraefteManagementPage />} />
        <Route path="taktische-karte" element={<TaktischeKartePage />} />
        <Route path="risikobewertung" element={<RisikobewertungPage />} />
        <Route path="live-video" element={<LiveVideoPage />} />
        <Route path="medien" element={<MedienPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="feedback" element={<FeedbackPage modul="fuehrung" />} />
        <Route path="*" element={<Navigate to="/verwaltung" replace />} />
      </Route>
      </Routes>
    </MissionProvider>
    </ConnectionProvider>
  )
}

function App() {
  return (
    <div className="app min-h-screen bg-dark-bg">
      <AppRoutes />
    </div>
  )
}

export default App